import React from 'react';

export default function Logo({ className = "", size = "md" }) {
  const sizes = {
    sm: "h-4",    // 6 * 0.7 ≈ 4
    md: "h-6",    // 8 * 0.7 ≈ 6
    lg: "h-8",    // 12 * 0.7 ≈ 8
    xl: "h-11"    // 16 * 0.7 ≈ 11
  };

  return (
    <div className="flex items-center">
      {/* AIMERKUR Logo - sadece görsel */}
      <img 
        src="https://customer-assets.emergentagent.com/job_merkur-ai/artifacts/phcuc1vc_A%C4%B0MERKUR.png" 
        alt="AIMERKUR Logo" 
        className={`${sizes[size]} ${className}`}
        style={{ objectFit: 'contain', maxWidth: 'auto' }}
      />
    </div>
  );
}
